import api from "@/lib/api";

// Chunked evidence upload: browser slices the file into 8MB parts and streams
// them to the backend, which buffers to a temp file and writes ONE object to
// R2 on complete. This keeps a 200MB video off a single request so the browser
// never times out. Any failure aborts the session (no ghost/partial file) and
// re-throws LOUDLY so the UI can surface it — never a silent lost file.
export async function uploadEvidence(findingId, file, { onProgress } = {}) {
    const { data: init } = await api.post(`/cctv/findings/${findingId}/evidence/init`, {
        filename: file.name,
        content_type: file.type || "application/octet-stream",
        size: file.size,
    });
    const evidenceId = init.evidence_id;
    const partSize = init.part_size || 8 * 1024 * 1024;
    try {
        let offset = 0;
        let part = 1;
        while (offset < file.size) {
            const blob = file.slice(offset, offset + partSize);
            const buf = await blob.arrayBuffer();
            await api.put(
                `/cctv/findings/${findingId}/evidence/${evidenceId}/part/${part}`,
                buf,
                { headers: { "Content-Type": "application/octet-stream" } }
            );
            offset += partSize;
            part += 1;
            if (onProgress) onProgress(Math.min(99, Math.round((offset / file.size) * 100)));
        }
        const { data: done } = await api.post(
            `/cctv/findings/${findingId}/evidence/${evidenceId}/complete`, {}
        );
        if (onProgress) onProgress(100);
        return done;
    } catch (e) {
        try {
            await api.post(`/cctv/findings/${findingId}/evidence/${evidenceId}/abort`, {});
        } catch (_) { /* best-effort cleanup */ }
        throw e;
    }
}
